import React, { useState } from 'react';
import { requestPreferencesLink } from './emailPreferencesApi';
import styles from './Email.module.css';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Asks for an address and emails a fresh, signed preferences link to it.
const RequestLinkForm = ({ submitLabel = 'Email me a link' }) => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    const value = email.trim();
    if (!EMAIL_RE.test(value)) {
      setError('Please enter a valid email address.');
      return;
    }
    setSending(true);
    const res = await requestPreferencesLink(value);
    setSending(false);
    if (res.ok) setSent(res.data?.message || 'If that address receives emails from Bubble Ai, a link is on its way.');
    else setError(res.error);
  };

  if (sent) {
    return (
      <p className={styles.success} role="status">
        {sent} Check your inbox (and spam folder). The link lets you manage emails without signing in.
      </p>
    );
  }

  return (
    <form className={styles.form} onSubmit={submit} noValidate>
      <label className={styles.label} htmlFor="email-pref-request">Email address</label>
      <input
        id="email-pref-request"
        className={styles.input}
        type="email"
        autoComplete="email"
        placeholder="you@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        maxLength={254}
        required
      />
      {error && <p className={styles.error} role="alert">{error}</p>}
      <button type="submit" className={styles.primaryBtn} disabled={sending}>
        {sending ? 'Sending…' : submitLabel}
      </button>
    </form>
  );
};

export default RequestLinkForm;
